import TrackingUseCriteo from './component'
import useCriteoFreespeeTrack from './use-criteo-freespee-track'
import useCriteoTrack, {criteoTrackEvents, criteoTrackPageEvents} from './use-criteo-track'

export {useCriteoTrack, useCriteoFreespeeTrack, criteoTrackEvents, criteoTrackPageEvents}
export default TrackingUseCriteo
